module.exports = __webpack_public_path__ + "static/media/sublimic-logo.a23f9864.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SalonConsultation/assets/sublimic-logo.svg
// module id = 354
// module chunks = 0